package com.karyadina.ui.screens.studyPlanner.presentation

import com.karyadina.model.*
import com.karyadina.service.FlashcardReviewNeed

// 1. The UI State (What the user sees)
data class StudyPlannerUiState(
    val isLoading: Boolean = false,
    val sessions: List<StudySession> = emptyList(),
    val subjects: List<Subject> = emptyList(),
    val stats: StudyStats = StudyStats(), // Default empty stats
    val flashcardReviews: List<FlashcardReviewNeed> = emptyList(),

    val subjectProgressMap: Map<String, Float> = emptyMap(),

    // Tab State
    val selectedTab: Int = 0, // 0 = Sessions, 1 = Subjects

    // Active Session State
    val activeSessionId: String? = null,
    val sessionElapsedTimeSeconds: Long = 0,

    // Dialog Visibility
    val isAddSessionDialogOpen: Boolean = false,
    val isAddSubjectDialogOpen: Boolean = false
)

// 2. The Events (What the user does)
sealed interface StudyPlannerEvent {
    data class SelectTab(val index: Int) : StudyPlannerEvent
    data object Refresh : StudyPlannerEvent

    // Session Actions
    data class StartSession(val sessionId: String) : StudyPlannerEvent
    data object StopSession : StudyPlannerEvent
    data class CompleteSession(val sessionId: String) : StudyPlannerEvent
    data class DeleteSession(val sessionId: String) : StudyPlannerEvent
    data class CreateSession(val session: StudySession) : StudyPlannerEvent

    // Subject Actions
    data class DeleteSubject(val subjectId: String) : StudyPlannerEvent
    data class CreateSubject(val subject: Subject) : StudyPlannerEvent

    // Dialogs
    data class ToggleAddSessionDialog(val isOpen: Boolean) : StudyPlannerEvent
    data class ToggleAddSubjectDialog(val isOpen: Boolean) : StudyPlannerEvent
}